import layout from '../layout.vue';
const _import = (file) => import(`./pages/${file}.vue`)

export default {
    path: '/home/',
    component:layout,
    children:[
        {name: '首页', path: 'index', component: ()=>_import('index')},
		{name: '关于我们', path: 'about', component: ()=>_import('about')},
        // add route here
    ]
}